var React = require('react');

function IconMarineCraft (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeLinejoin":"round","transform":"translate(13 15.25)"},[React.createElement("path",{"d":"m120.6 94.4c25.9 0 53.2-27 58.5-34.1.8-1 .9-2.4.2-3.6-4.4-8-23-38.9-44.3-36.2l-37.4 5.3-14.9 16.3-61.5 8.1-19.9 22.1c-1 1.1-1.1 2.8-.3 4l13.7 16.5","key":0}),React.createElement("path",{"d":"m37.2 48.1-.2-2c-.4-3.5 2.1-6.8 5.6-7.2l19-2.6c3.5-.5 6.8 2 7.3 5.6l.3 2","key":1}),React.createElement("path",{"d":"m119.1 22.8-11.7-12.3 11.3-4.2c1.9-.7 4.1-.5 5.8.7l23.6 15.8","key":2}),React.createElement("path",{"d":"m82.7 1.9 21.7-1.9 9.5 8.1","key":3}),React.createElement("path",{"d":"m0 101.9s21.5-19 61.6-19 50.4 13.7 76.6 13.7 43.3-15.5 43.3-15.5","key":4}),React.createElement("path",{"d":"m.5 74.1 178.8-17.3","key":5})]));
}

IconMarineCraft.defaultProps = {"viewBox":"0 0 208 128"};

module.exports = IconMarineCraft;

IconMarineCraft.default = IconMarineCraft;
